module.exports = __webpack_public_path__ + "img/wishList.9a30a383.svg";